export default __webpack_public_path__ + "static/media/chuck-web-gift.3c94907e.gif";